import { AppItemRecommendations } from 'components/pages/CartPage/ItemRecommendations/types/query'
import Image from 'components/Image'
import Button from 'components/ui/Button'

type Props = {
  locationItem: NonNullable<
    AppItemRecommendations['currentCart']
  >['itemRecommendations'][0]
  openModal: (itemId: number) => void
}

export default function ItemRecommendationCard({
  locationItem,
  openModal
}: Props) {
  const isActive = locationItem.status === 'active'

  return (
    <div
      className="w-40 outline-none-mouse group invisible-scroll border border-solid border-gray-100 shadow-sm rounded-lg box-border p-3 bg-white overflow-hidden h-full flex flex-col justify-between cursor-pointer"
      onClick={() => isActive && openModal(locationItem.id)}
      onKeyDown={(e) => {
        if (e.keyCode === 13) {
          return isActive && openModal(locationItem.id)
        }
        return null
      }}
      role="button"
      tabIndex={0}
    >
      <div>
        <div className="-mt-3 -mx-3 relative">
          <div className="w-full relative">
            <Image
              alt={locationItem.item.name}
              height={200}
              layout="responsive"
              sizes="25vw"
              src={locationItem.item.image.medium}
              width={200}
            />
          </div>
        </div>
        <p className="py-3 text-center text-sm">{locationItem.item.name}</p>
      </div>

      {isActive && (
        <>
          <Button color="secondary" size="small" variant="contained" fullWidth>
            Add{' '}
            <div className="ml-2 text-center font-semibold text-sm">
              {locationItem.item.price.formatted}
            </div>
          </Button>
        </>
      )}

      {!isActive && <p className="text-gray-400 text-sm">Out of stock</p>}
    </div>
  )
}
